import store from '../store/store';
import { DEFAULT_NEW_CATEGORY_COLOR_CODE } from 'owa-categories';
import { getGuid } from 'owa-guid';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('createNewCategoryRow', function createNewCategoryRow() {
    store.newCategory = {
        Id: getGuid(),
        Name: '',
        Color: DEFAULT_NEW_CATEGORY_COLOR_CODE,
    };
});
//# sourceMappingURL=createNewCategoryRow.js.map